export function parseCookiesFromCookieHeader(cookieHeader: string | null) {
  if (!cookieHeader || !cookieHeader.length) return {}
  return cookieHeader.split('; ').reduce((cookies: Record<string, string>, pair) => {
    const [name, ...value] = pair.split('=')
    cookies[name] = decodeURIComponent(value.join('='))
    return cookies
  }, {})
}

export function objectToSetCookieHeaders(obj: Record<string, any>) {
  return Object.entries(obj)
    .filter(([key, value]) => key !== undefined && value !== undefined)
    .map(([key, val]) => `${key}=${typeof val === 'object' ? JSON.stringify(val) : val}; Path=/; SameSite=Lax`)
}

export function urlIsRedirect(urlString: string) {
  try {
    const url = new URL(urlString)
    const pathNames = url.pathname.split('/')
    return (
      pathNames.length &&
      (pathNames[pathNames.length - 1] === 'redirect' || pathNames[pathNames.length - 1] === 'redirect-analytics')
    )
  } catch (_) {
    // intentionally empty — URL parse failure returns false below
  }

  return false
}

export function generateId() {
  return Math.random().toString().slice(2, 16)
}

export function objectToQueryString(obj: Record<string, any>) {
  return Object.keys(obj)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    .join('&')
}

export function camelToSnakeCase(str: string) {
  return str?.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function generateRandomAroundPivot(pivot: number, range: number) {
  const min = pivot - range
  const max = pivot + range
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getAsinBasedSemiRandomNumber(asin: string, from: number, to: number) {
  return [...asin].reduce((sum, char) => sum + char.charCodeAt(0), 0) % (to - from)
}

export const getDailyNumber = (min = 75, max = 90) => {
  const date = new Date().toISOString().split('T')[0] // YYYY-MM-DD
  const hash = [...date].reduce((acc, char) => acc * 31 + char.charCodeAt(0), 0)
  const normalized = (Math.abs(hash) % 1000) / 1000
  return Math.floor(normalized * (max - min + 1)) + min
}

export function getCurrentYear() {
  return new Date().getUTCFullYear()
}

export function getUtcDateDaysAgo(baseTimestamp: number, daysAgo: number) {
  const date = new Date(baseTimestamp)
  date.setUTCDate(date.getUTCDate() - daysAgo)
  return date
}

export function getSchemaPriceValidUntil(baseTimestamp: number, locale: string = 'en-CA') {
  const date = new Date(baseTimestamp)
  const nextMonthFirstDayUtc = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1))
  return nextMonthFirstDayUtc.toLocaleDateString(locale, {timeZone: 'UTC'})
}

export function readCookie(name: string) {
  const cookieHeader = (globalThis as {document?: {cookie?: string}}).document?.cookie
  const match = cookieHeader?.split('; ').find((row: string) => row.startsWith(name))
  return match ? decodeURIComponent(match.split('=')[1]) : null
}

export function decodeFromBase64(inputString: string, encoding: 'base64' | 'base64url' = 'base64') {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(inputString, encoding).toString('utf-8')
  }
  if (encoding === 'base64url') {
    let base64 = inputString.replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4) {
      base64 += '='
    }
    return atob(base64)
  }
  return atob(inputString)
}
